const en = {
	nav: {
		home: 'HOME',
		california: 'CALIFORNIA',
		texas: 'TEXAS',
		florida: 'FLORIDA',
		menu: 'MENU',
		faq: 'FAQ',
		freeEstimate: 'Free Estimate',
		bookNow: 'BOOK NOW',
		myBooking: 'My Booking',
	},
	seo: {
		homeDescription: 'Top Rated Hibachi At Home Experience. We bring our Hibachi Grill + Chef to your backyard in California, Texas, and Florida.',
	},
	hero: {
		title: 'HAPPY HIBACHI',
		tagline: '#1 Rated Hibachi At Home',
		subtitle: 'Experience authentic Japanese hibachi cooking at your home',
		description: 'Professional chefs bring the excitement of hibachi-style cooking directly to your backyard.',
		bookNow: 'Book Now',
		freeEstimate: 'Free Estimate',
	},
	howItWorks: {
		title: 'How It Works',
		subtitle: 'Simple steps to your perfect hibachi party',
		step1: { title: 'Book Online', description: 'Choose your date, time, and menu preferences' },
		step2: { title: 'We Prepare', description: 'Our team handles all ingredients and equipment' },
		step3: { title: 'Enjoy the Show', description: 'Watch our chef perform and enjoy delicious food' },
		step4: { title: 'We Clean Up', description: 'Relax while we handle all the cleanup' },
	},
	menu: {
		title: 'Pricing & Service',
		subtitle: 'Fresh ingredients, authentic flavors',
		proteins: 'Proteins',
		sides: 'Sides & Appetizers',
		chicken: 'Chicken',
		steak: 'Filet Mignon',
		shrimp: 'Shrimp',
		salmon: 'Salmon',
		lobster: 'Lobster Tail',
		tofu: 'Tofu (Vegetarian)',
		friedRice: 'Hibachi Fried Rice',
		noodles: 'Yakisoba Noodles',
		vegetables: 'Grilled Vegetables',
		salad: 'Ginger Salad',
		soup: 'Miso Soup',
		edamame: 'Edamame',
		includes: {
			salad: 'Fresh Salad',
			rice: 'Fried Rice',
			vegetables: 'Hibachi Vegetables',
			show: 'Game & Show',
		},
		protein: {
			title: 'Protein Choices',
			included: 'Included',
		},
		upgrades: {
			title: 'Premium Upgrades',
			filet: 'Filet Mignon',
			lobster: 'Lobster',
			ribeye: 'Premium Ribeye',
			shrimp: 'Jumbo Shrimp',
			salmon: 'Wild Salmon',
			scallops: 'Large Scallops',
		},
		addons: {
			title: 'Add-ons',
			gyoza: 'Gyoza (12pcs)',
			edamame: 'Edamame',
			noodles: 'Noodles',
			thirdProtein: '3rd Protein',
		},
		coupon: {
			title: 'Special Coupons',
			subtitle: 'Sunday to Friday parties only!',
			email: 'Email us at',
		},
		note: {
			outdoor: 'We cook outside only.',
			weather: 'We provide services rain or shine, as long as there is a dry area for the chef to cook under.',
		},
	},
	pricing: {
		title: 'Pricing',
		subtitle: 'Transparent pricing with no hidden fees',
		perPerson: 'person',
		minimum: 'minimum for all parties',
		kids: 'per child 12 and under',
		includes: 'Includes',
		includesList: {
			chef: 'Professional hibachi chef',
			ingredients: 'All ingredients and supplies',
			equipment: 'Hibachi grill and equipment',
			setup: 'Setup and cleanup',
			show: 'Live cooking entertainment',
		},
		basic: { title: 'Basic Package', description: 'Perfect for intimate gatherings' },
		premium: { title: 'Premium Package', description: 'Complete hibachi experience' },
		deluxe: { title: 'Deluxe Package', description: 'Ultimate luxury dining' },
	},
	calendar: {
		available: 'Available',
		limited: 'Limited',
		busy: 'Busy',
		unavailable: 'Unavailable',
		today: 'Today',
		prevMonth: 'Previous month',
		nextMonth: 'Next month',
		weekdays: {
			sun: 'Sun',
			mon: 'Mon',
			tue: 'Tue',
			wed: 'Wed',
			thu: 'Thu',
			fri: 'Fri',
			sat: 'Sat',
		},
		months: {
			january: 'January',
			february: 'February',
			march: 'March',
			april: 'April',
			may: 'May',
			june: 'June',
			july: 'July',
			august: 'August',
			september: 'September',
			october: 'October',
			november: 'November',
			december: 'December',
		},
	},
	slider: {
		chef: 'Professional Hibachi Chef in Action',
		steak: 'Delicious Hibachi Steak',
		shrimp: 'Amazing Hibachi Shrimp',
		setup: 'Premium Hibachi Setup',
		presentation: 'Beautiful Food Presentation',
	},
	booking: {
		title: 'Book Your Event',
		subtitle: 'Select your region to get started',
		selectRegion: 'Select your region to get started',
		california: 'California',
		texas: 'Texas',
		florida: 'Florida',
		californiaTagline: 'Professional hibachi at your doorstep',
		texasTagline: 'Bringing hibachi excellence to Texas',
		floridaTagline: 'Sunshine state hibachi experience',
		servingAreas: 'Areas We Serve',
		bookIn: 'Book Now',
		note: '* No payment required. We will contact you to confirm.',
		quickBook: 'Quick Book:',
		summary: 'Booking Details',
		addToCalendar: 'Add to Calendar',
	},
	gallery: {
		title: 'Gallery',
		subtitle: 'Experience the Happy Hibachi difference',
		items: {
			chef: 'Professional Hibachi Chef',
			chefDesc: 'Professional Hibachi Chef in Action',
			grill: 'Hibachi Grill Setup',
			grillDesc: 'Premium Hibachi Grill Setup',
			steak: 'Hibachi Steak',
			steakDesc: 'Delicious Hibachi Steak',
			vegetables: 'Hibachi Vegetables',
			vegetablesDesc: 'Fresh Hibachi Vegetables',
			shrimp: 'Hibachi Shrimp',
			shrimpDesc: 'Amazing Hibachi Shrimp',
			food: 'Food Presentation',
			foodDesc: 'Beautiful Food Presentation',
		},
	},
	calculator: {
		title: 'Price Calculator',
		subtitle: 'Get an instant estimate for your event',
		guests: 'Number of Guests',
		adults: 'Adults',
		kids: 'Kids (10 & under)',
		upgrades: 'Optional Upgrades',
		summary: 'Price Summary',
		subtotal: 'Subtotal',
		discount: 'Group Discount',
		minimum: 'Minimum Order',
		total: 'Total',
		gratuity: 'Suggested Gratuity',
		grandTotal: 'Grand Total',
		bookNow: 'Book Your Event',
		note: '* Travel fees may apply based on location. Final price confirmed at booking.',
		minimumNotice: 'Minimum 10 guests required',
		thirdProtein: '3rd Protein',
		noodles: 'Noodles',
	},
	reviews: {
		title: 'Customer Reviews',
		subtitle: 'See what our customers are saying about their Happy Hibachi experience',
		bookNow: 'Book Your Event',
		ctaTitle: 'Ready to Create Your Own Amazing Experience?',
		ctaText: 'Join hundreds of satisfied customers',
		rating: '5.0 Average Rating',
		verified: '100+ Verified Reviews',
		topRated: 'Top Rated Service',
	},
	instagram: {
		title: 'Follow Our Journey',
		followUs: 'FOLLOW US ON INSTAGRAM',
	},
	referral: {
		title: 'Refer Friends, Earn Rewards',
		subtitle: 'Share the hibachi love and get rewarded!',
		step1Title: 'Share Your Code',
		step1Desc: 'Share your unique referral code with friends and family',
		step2Title: 'Friend Books',
		step2Desc: 'Your friend gets $30 off their first booking',
		step3Title: 'You Get Rewarded',
		step3Desc: 'Earn $50 credit for your next event',
		yourReward: 'Your Reward',
		friendDiscount: "Friend's Discount",
		getCode: 'Get Your Referral Code',
		emailPlaceholder: 'Enter your email',
		invalidEmail: 'Please enter a valid email',
		getCodeBtn: 'Get Code',
		successTitle: 'Your Referral Code is Ready!',
		successDesc: 'Check your email for your unique referral code and instructions.',
		terms: '* Rewards apply after your friend completes their first booking. No limit on referrals!',
	},
	newsletter: {
		title: 'Get Exclusive Offers',
		subtitle: 'Subscribe to our newsletter for special deals and party tips!',
		placeholder: 'Enter your email address',
		subscribe: 'Subscribe',
		invalidEmail: 'Please enter a valid email address',
		success: 'Thank you for subscribing! Check your inbox for exclusive offers.',
		error: 'Something went wrong. Please try again.',
		privacy: 'We respect your privacy. Unsubscribe anytime.',
		benefit1: 'Exclusive discounts',
		benefit2: 'Party planning tips',
		benefit3: 'New menu updates',
	},
	myBooking: {
		title: 'Check My Booking',
		subtitle: 'Enter the email or phone number you used when booking',
		emailPlaceholder: 'Enter your email address',
		phonePlaceholder: 'Enter your phone number',
		search: 'Search Booking',
		searching: 'Searching...',
		results: 'Results',
		noResults: 'No bookings found',
		error: 'Search failed, please try again',
		bookingId: 'Booking ID',
		needHelp: 'Need Help?',
		contactUs: 'If you have any questions, feel free to contact us',
		pendingNote: 'We will contact you within 2 hours to confirm',
		confirmedNote: 'Looking forward to seeing you! Chef will arrive 30 minutes early',
	},
	faq: {
		title: 'FAQ',
		subtitle: 'Everything you need to know',
		q1: 'What areas do you serve?',
		a1: 'We currently serve California, Texas, and Florida. Please contact us to verify if we cover your specific location.',
		q2: 'How many guests can you accommodate?',
		a2: 'We require a minimum of 10 guests and can accommodate up to 50. For larger events, contact us for special arrangements.',
		q3: 'What do I need to provide?',
		a3: 'You just need to provide the space and your guests! We bring all equipment, ingredients, utensils, and handle all setup and cleanup.',
		q4: 'How far in advance should I book?',
		a4: 'We recommend booking at least 2 weeks ahead for weekday events and 3-4 weeks for weekends. Popular dates book up fast!',
		q5: 'Can you accommodate dietary restrictions?',
		a5: 'Yes! We offer vegetarian options and can accommodate most dietary restrictions. Please let us know when booking.',
		q6: 'What is your cancellation policy?',
		a6: 'Full refund if cancelled 7+ days before the event. 50% refund with 3-6 days notice. No refund with less than 3 days notice.',
	},
	contact: {
		title: 'Contact Us',
		subtitle: 'Get in touch',
		phone: 'Phone',
		email: 'Email',
		hours: 'Business Hours',
		address: 'Service Areas',
	},
	footer: {
		description: 'Bringing authentic hibachi experience to your home',
		quickLinks: 'Quick Links',
		contact: 'Contact',
		followUs: 'Follow Us',
		copyright: '© 2024 Happy Hibachi. All rights reserved.',
		allRightsReserved: 'All Rights Reserved.',
		privacyPolicy: 'Privacy Policy',
		termsOfService: 'Terms of Service',
	},
	menuSelection: {
		title: 'SELECT YOUR DISH TYPE',
		subtitle: 'All meals include steamed rice, hibachi vegetables, and signature sauces',
		regular: {
			title: 'REGULAR',
			proteins: '2 proteins per person',
			service: 'Show included, 90 min service',
		},
		premium: {
			title: 'PREMIUM',
			proteins: '2 premium proteins: Filet Mignon, Lobster, Scallops',
			service: 'Show included, 120 min service',
		},
		catering: {
			title: 'LARGE GATHERING',
			note: '50+ guests buffet style',
			proteins: '2 proteins per person',
			service: 'Shows included, 3-4 hours service',
		},
		intimate: {
			title: 'INTIMATE PARTY',
			note: '5-7 guests',
			includes: 'Salads, gyoza, edamame, noodles + mixed proteins',
			substitution: 'Same-price proteins can be substituted',
		},
	},
	form: {
		name: 'Full Name',
		namePlaceholder: 'Enter your full name',
		email: 'Email Address',
		emailPlaceholder: 'your@email.com',
		phone: 'Phone Number',
		phonePlaceholder: '(123) 456-7890',
		date: 'Event Date',
		time: 'Preferred Time',
		guests: 'Number of Guests',
		guestsHint: 'Minimum 10 guests',
		region: 'Select Region',
		eventType: 'Event Type',
		message: 'Additional Message',
		messagePlaceholder: 'Tell us about your event...',
		selectOption: 'Select an option',
		selectDate: 'Select date',
		submit: 'Submit',
		submitting: 'Submitting...',
		submitReservation: 'Submit Reservation',
		success: 'Booking Submitted!',
		successMessage: 'Your booking request has been received. We will contact you within 2 hours to confirm.',
		weWillContact: 'We will contact you shortly to confirm details.',
		error: 'Something went wrong. Please try again.',
		required: 'Required',
		people: 'people',
		noPaymentRequired: '* No payment required now. We will contact you to confirm.',
		invalidEmail: 'Please enter a valid email address',
		invalidPhone: 'Please enter a valid phone number',
		eventTypes: {
			birthday: 'Birthday Party',
			anniversary: 'Anniversary',
			graduation: 'Graduation',
			corporate: 'Corporate Event',
			holiday: 'Holiday Party',
			other: 'Other',
		},
		referralSource: 'How did you hear about us?',
		referral: {
			google: 'Google Search',
			friend: 'Friend Referral',
			event: 'Seen at Event',
			other: 'Other',
		},
		couponCode: 'Coupon Code',
		couponPlaceholder: 'Enter coupon code (optional)',
		applyCoupon: 'Apply',
	},
	estimate: {
		title: 'Get Your Free Estimate',
		subtitle: 'Tell us about your event and we will provide a custom quote',
		benefits: {
			title: 'Why Choose Us?',
			professional: 'Professionally trained chefs',
			fresh: 'Fresh, high-quality ingredients',
			entertainment: 'Live cooking entertainment',
			cleanup: 'Complete setup and cleanup',
			custom: 'Customizable menu options',
		},
	},
	bookNow: {
		title: 'Book Your Hibachi Party',
		subtitle: 'Fill out the form below to reserve your date',
		selectRegion: 'First, select your region',
		formTitle: 'Event Details',
		pricing: 'Pricing from $45/person',
		note: 'We will confirm availability within 2 hours',
	},
	notFound: {
		title: 'Page Not Found',
		description: 'The page you are looking for does not exist.',
		backHome: 'Back to Home',
	},
	common: {
		learnMore: 'Learn More',
		viewAll: 'View All',
		loading: 'Loading...',
		close: 'Close',
		backToHome: 'Back to Home',
		total: 'Total',
		toBeConfirmed: 'To be confirmed',
		specialOffer: 'Special Offer',
		goTo: 'Go to',
		previous: 'Previous',
		next: 'Next',
	},
	topBar: {
		textUs: 'Text Us',
		email: 'Email',
	},
	photoShare: {
		title: 'Share Your Photos',
		subtitle: 'Post your Happy Hibachi experience and get $25 off your next event!',
		option1Title: 'Post on Instagram',
		option1Desc: 'Tag us and use #HappyHibachi',
		option2Title: 'Upload Directly',
		option2Desc: 'Share your photos with us',
		dropzone: 'Drag & drop photos here or click to browse',
		maxFiles: 'Up to 5 photos',
		instagramPlaceholder: 'Your Instagram handle (optional)',
		submit: 'Submit Photos',
		submitting: 'Uploading...',
		successTitle: 'Photos Submitted!',
		successDesc: 'Thank you for sharing! Your $25 credit will be applied to your next booking.',
		terms: '* Credit applied after photo review. Photos may be featured on our social media.',
	},
	offer: {
		noTravel: 'No Travel Fees',
		within50: 'Within 50 Miles',
		noHidden: 'No hidden charges',
		exclusive: 'Exclusive discounts',
		freeSetup: 'Free tables & chairs',
		sunFri: 'Sunday to Friday Special!',
	},
	coupon: {
		minGuests: 'Minimum {{count}} guests required',
		applied: 'Coupon applied! Discount: {{discount}}',
		invalid: 'Invalid coupon code',
		checkFailed: 'Verification failed',
		under15: 'under 15 people',
		range15to25: '15-25 people',
		range25to35: '25-35 people',
		over35: '35+ people',
	},
	privacy: {
		title: 'Privacy Policy',
		lastUpdated: 'Last updated: January 2026',
		section1: {
			title: '1. Information We Collect',
			intro: 'When you use Happy Hibachi services, we may collect:',
			contact: 'Contact Information',
			contactDesc: 'Name, email address, phone number',
			booking: 'Booking Details',
			bookingDesc: 'Event date, time, location, number of guests',
			payment: 'Payment Information',
			paymentDesc: 'Processed securely through third-party providers',
			usage: 'Usage Data',
			usageDesc: 'How you interact with our website',
		},
		section2: {
			title: '2. How We Use Your Information',
			item1: 'Process and confirm your bookings',
			item2: 'Send booking confirmations and reminders',
			item3: 'Respond to your inquiries',
			item4: 'Improve our services',
			item5: 'Send promotional offers (with your consent)',
		},
		section3: {
			title: '3. Information Sharing',
			intro: 'We do not sell your personal information. We may share information with:',
			item1: 'Service providers who assist in our operations',
			item2: 'Legal authorities when required by law',
		},
		section4: {
			title: '4. Data Security',
			desc: 'We implement appropriate security measures to protect your personal information. However, no internet transmission is 100% secure.',
		},
		section5: {
			title: '5. Your Rights',
			intro: 'You have the right to:',
			item1: 'Access your personal data',
			item2: 'Request correction of inaccurate data',
			item3: 'Request deletion of your data',
			item4: 'Opt-out of marketing communications',
		},
		section6: {
			title: '6. Cookies',
			desc: 'We use cookies to improve your browsing experience and analyze site traffic. You can control cookies through your browser settings.',
		},
		section7: {
			title: '7. Contact Us',
			intro: 'For privacy-related questions:',
		},
	},
	terms: {
		title: 'Terms of Service',
		lastUpdated: 'Last updated: January 2026',
		section1: {
			title: '1. Services',
			desc: 'Happy Hibachi provides mobile hibachi catering services. We bring professional chefs and equipment to your location to prepare authentic hibachi meals.',
		},
		section2: {
			title: '2. Booking & Reservations',
			minimum: 'Minimum Guests',
			minimumDesc: '10 guests minimum required',
			confirmation: 'Confirmation',
			confirmationDesc: 'Bookings are confirmed after our team contacts you',
			deposit: 'Deposit',
			depositDesc: 'A deposit may be required to secure your date',
			finalCount: 'Final Count',
			finalCountDesc: 'Guest count must be confirmed 48 hours before the event',
		},
		section3: {
			title: '3. Cancellation Policy',
			sevenDays: '7+ days notice',
			sevenDaysDesc: 'Full refund of deposit',
			threeSixDays: '3-6 days notice',
			threeSixDaysDesc: '50% of deposit refunded',
			lessThanThree: 'Less than 3 days',
			lessThanThreeDesc: 'Deposit is non-refundable',
			weather: 'Weather',
			weatherDesc: 'We will reschedule at no charge for severe weather',
		},
		section4: {
			title: '4. Customer Responsibilities',
			intro: 'Customers must provide:',
			item1: 'Adequate outdoor space for cooking (minimum 10x10 feet)',
			item2: 'Access to electricity (standard outlet within 50 feet)',
			item3: 'Tables and seating for guests',
			item4: 'Weather protection if needed (tent, gazebo, etc.)',
		},
		section5: {
			title: '5. Food Safety & Allergies',
			desc: 'Please inform us of any food allergies or dietary restrictions at the time of booking. While we take precautions, we cannot guarantee a completely allergen-free environment due to the nature of hibachi cooking.',
		},
		section6: {
			title: '6. Liability',
			desc: 'Happy Hibachi carries liability insurance. However, customers are responsible for their guests and property. We are not liable for accidents caused by guest behavior or pre-existing property conditions.',
		},
		section7: {
			title: '7. Service Area',
			intro: 'We currently serve:',
			california: 'California (Los Angeles, San Diego, San Francisco, and surrounding areas)',
			texas: 'Texas (Houston, Dallas, Austin, San Antonio, and surrounding areas)',
			florida: 'Florida (Miami, Fort Lauderdale, and surrounding areas)',
			travelFee: 'Travel fees may apply for locations outside our standard service area.',
		},
		section8: {
			title: '8. Changes to Terms',
			desc: 'We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of updated terms.',
		},
		section9: {
			title: '9. Contact',
			intro: 'Questions about these terms:',
		},
	},
	status: {
		pending: 'Pending',
		confirmed: 'Confirmed',
		completed: 'Completed',
		cancelled: 'Cancelled',
	},
	timeSlot: {
		afternoon: 'Afternoon',
		evening: 'Evening',
		night: 'Night',
	},
	admin: {
		login: {
			title: 'Admin Login',
			subtitle: 'Enter password to continue',
			password: 'Password',
			loginButton: 'Login',
			loggingIn: 'Logging in...',
			invalidPassword: 'Invalid password',
			loginFailed: 'Login failed',
			contactHelp: 'Contact for help',
		},
		dashboard: {
			title: 'Admin Dashboard',
			logout: 'Logout',
		},
		stats: {
			totalBookings: 'Total',
			pending: 'Pending',
			confirmed: 'Confirmed',
			completed: 'Completed',
			cancelled: 'Cancelled',
			totalGuests: 'Total Guests',
		},
		tabs: {
			all: 'All',
			pending: 'Pending',
			confirmed: 'Confirmed',
			completed: 'Completed',
			cancelled: 'Cancelled',
		},
		booking: {
			noBookings: 'No bookings',
			noBookingsHint: 'Bookings will appear here',
			guests: 'guests',
			booking: 'Booking',
			estimate: 'Estimate',
			contactInfo: 'Contact Info',
			eventDetails: 'Event Details',
			date: 'Date',
			time: 'Time',
			notSpecified: 'Not specified',
			region: 'Region',
			additionalNotes: 'Additional Notes',
			updateStatus: 'Update Status',
			emailCustomer: 'Email Customer',
			callCustomer: 'Call Customer',
		},
	},
};

export default en;
